// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_popover.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for initializing Bootstrap popovers on elements that have 
//     the `data-bs-toggle="popover"` attribute, enabling popover functionality in a Blazor application.
// </summary>
// ***********************************************************************

window.popover = window.popover || {};

/**
 * Initializes all elements with the attribute `data-bs-toggle="popover"` as Bootstrap popovers.
 * This function scans the DOM for elements with the `data-bs-toggle="popover"` attribute and
 * initializes a Bootstrap popover instance for each one, enabling popover functionality.
 *
 * @function initialize
 * @memberof window.popover
 */
window.popover.initialize = function () {
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.map(function (popoverTriggerEl) {
        return new window.bootstrap.Popover(popoverTriggerEl);
    });
};